export default function RegulatoryDocuments() {
  return (
    <div className="prose max-w-none">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Նորմատիվ փաստաթղթեր</h2>
    </div>
  );
}
